
import { HttpResponse, defaultHttpResponse } from "../auth/AuthInterface";

import { PaginacionProps } from "../global/PaginacionInterface";

import { defaultExhortoRecibido, ExhortoRecibidoProps } from "../recepcion/ExhortoRecibidoInterface";
import { defaultExpediente, ExpedienteProps } from "../recepcion/ExpedienteInterface";

// Definición de defaults

export const defaultExhortoLibrado: ExhortoLibradoProps = {
    idExhortoLibrado: 0,
    numeroExhorto: '',
    contenido: '',
    idPlantilla: 0,
    juez: '',
    idObjetoExhorto: 0,
    objetoExhorto: '',
    idClaseExhorto: 0,
    claseExhorto: '',
    documento: '',
    idDistritoJudicial: 0,
    distritoJudicial: '',
    dirigidoJuzgadoEstado: false,
    idExpediente: 0,
    expediente: defaultExpediente,
    idEstatus: 0,
    observaciones: [],
    nombreUsuarioAsignado: '',
    asignadoMismoUsuario: false,
    idExhortoRecibido: 0,
    exhortoRecibido: defaultExhortoRecibido
}

export const defaultDetalleExhortoLibrado: DetalleExhortoLibradoResponse = {
    ...defaultHttpResponse,
    ...defaultExhortoLibrado,
}

export const defaultNuevoExhortoLibrado: NuevoExhortoLibradoResponse = {
    ...defaultHttpResponse,
    idExhortoLibrado: '',
}

export const defaultActualizarEstatus: ActualizarEstatusResponse = {
    ...defaultHttpResponse,
    nombreUsuarioAsignado: '',
    asignadoMismoUsuario: false,
}

export const defaultConsultaExhortosLibrados: ConsultaExhortosLibradosResponse = {
    currentPageIndex: 0,
    pageCount: 0,
    recordsCount: 0,
    records: [],
}

//Creación de interfaces

export interface NuevoExhortoLibradoParams {
    idExpediente:           number;
    idExhortoRecibido:      number;
}

export interface NuevoExhortoLibradoResponse extends HttpResponse {
    idExhortoLibrado:       string;
}

export interface GuardarExhortoLibradoParams {
    idExhortoLibrado:       string;
    idPlantilla:            number;
    contenido:              string;
    idDistritoJudicial:     number;
    idObjetoExhorto:        number;
    idClaseExhorto:         number;
    dirigidoJuzgadoEstado:  boolean;
}

export interface ActualizarEstatusParams    {
    idExhortoLibrado:       string;
    idEstatus:              number;
    observacion:            string;
}

export interface ActualizarEstatusResponse {
    success:                    boolean;
    message:                    string;
    nombreUsuarioAsignado:      string;
    asignadoMismoUsuario:       boolean;
}

export interface ExhortoLibradoObservacionesProps { 
    usuario:        string;
    puesto:         string;
    observacion:    string;
    fecha?:         Date;
}

export interface ExhortoLibradoProps   {
    idExhortoLibrado:           number;
    numeroExhorto:              string;
    contenido:                  string;
    documento:                  string;
    idPlantilla:                number;
    juez:                       string;
    idObjetoExhorto:            number;
    objetoExhorto:              string;
    idClaseExhorto:             number;
    claseExhorto:               string;
    idDistritoJudicial:         number;
    distritoJudicial:           string;
    dirigidoJuzgadoEstado:      boolean;
    idExpediente:               number;
    expediente:                 ExpedienteProps;
    idExhortoRecibido:          number;
    exhortoRecibido:            ExhortoRecibidoProps;
    idEstatus:                  number;
    observaciones:              ExhortoLibradoObservacionesProps[];
    nombreUsuarioAsignado:      string
    asignadoMismoUsuario:       boolean;
    fecha?:                     Date;
}

export interface DetalleExhortoLibradoResponse extends HttpResponse, ExhortoLibradoProps { }

export interface ConsultarExhortosLibradosParams extends PaginacionProps {
    fecha:                          string;
    idAutoridad:                    number;
    idMateria:                      number;
    idObjetoExhorto:                number;
    idClaseExhorto:                 number;
    idEstatus:                      number;
    referencia:                     string;
    idUsuarioElaboro:               number;
    idUsuarioAsignacion:            number;
}

export interface DescargarExhortosLibradosParams {
    fecha:                          string;
    idAutoridad:                    number;
    idMateria:                      number;
    idEstatus:                      number;
    idObjetoExhorto:                number;
    idClaseExhorto:                 number;
    referencia:                     string;
    idUsuarioElaboro:               number;
    idUsuarioAsignacion:            number;
}

export interface ConsultaExhortosLibradosProps {
    idExhortoLibrado:               number;
    numeroSeguimiento:              string;
    numeroExhorto:                  string;
    referencia:                     string;
    objetoExhorto:                  string;
    autoridadExhorto:               string;
    idClaseExhorto:                 number;
    claseExhorto:                   string;
    idEstatus:                      number;
    estatus:                        string;
    documento:                      string;
    usuarioElaboro:                 string;
    usuarioAsignado:                string;
    expediente:                     ExpedienteProps;
    exhortoRecibido:                ExhortoRecibidoProps;
    fecha?:                         Date;
}

export interface ConsultaExhortosLibradosResponse {
    currentPageIndex:               number;
    pageCount:                      number;
    recordsCount:                   number;
    records:                        ConsultaExhortosLibradosProps[];
}